import React from "react";

import { PropsTypeSvg } from "@typings/global.types";

function MsTargetGreySvg({ classNameProps, width, height }: PropsTypeSvg) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNameProps}
      width={width}
      height={height}
      viewBox='0 0 200 200'
      fill='none'
    >
      <rect width='200' height='200' fill='none' />
      <path
        d='M99.5 33C62.2773 33 32 63.2773 32 100.5C32 137.723 62.2773 168 99.5 168C136.723 168 167 137.723 167 100.5C167.109 63.2773 136.831 33 99.5 33ZM99.5 142.064C76.7106 142.064 58.045 123.398 58.045 100.5C58.045 77.7106 76.7106 59.045 99.5 59.045C122.398 59.045 140.955 77.7106 140.955 100.5C141.064 123.398 122.398 142.064 99.5 142.064ZM99.5 80.3151C88.4309 80.3151 79.3151 89.4309 79.3151 100.5C79.3151 111.678 88.3223 120.685 99.5 120.685C110.678 120.685 119.685 111.678 119.685 100.5C119.793 89.4309 110.678 80.3151 99.5 80.3151Z'
        fill='currentColor'
      />
    </svg>
  );
}

export default MsTargetGreySvg;
